// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { formatCash, calculateProfit } from 'utils/utils';

// Define a service using a base URL and expected endpoints
export const pricesApi = createApi({
  reducerPath: '@finance/prices',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://us-central1-adan-farmacia.cloudfunctions.net'
  }),
  endpoints: (builder) => ({
    getFinancePrices: builder.mutation({
      query: (body = { offset: 1, limit: 10 }) => ({
        url: '/adan_pricing_tool',
        method: 'POST',
        body
      }),
      transformResponse: ({ total, data }) => ({
        data: data.map((item) => ({
          ...item,
          price: 0
        })),
        total
      })
    }),
    setAllDuplicatePrices: builder.mutation({
      query: (limit = 10) => ({
        url: '/adan_pricing_tool',
        method: 'POST',
        body: { offset: 1, limit }
      }),
      transformResponse: ({ data }) => {
        return {
          ...data.reduce((acc, item) => {
            return {
              ...acc,
              [item.external_id]: {
                ...item,
                price: formatCash(
                  Number(item.precio_sugerido_DOLAR.toFixed(2))
                ),
                profit: calculateProfit(
                  item.precio_sugerido_DOLAR,
                  item.costo_adan_dolar
                )
              }
            };
          }, {})
        };
      }
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetFinancePricesMutation, useSetAllDuplicatePricesMutation } =
  pricesApi;
